import type { IMetadataRepository, MetadataListOptions } from '../repositories/IMetadataRepository.js';
import type { MetadataEntity } from '../entities/MetadataEntity.js';

interface Deps { metadataRepository: IMetadataRepository; }
export function createListMetadatasUseCase({ metadataRepository }: Deps) {
  return async function listMetadatas(options: MetadataListOptions): Promise<MetadataEntity[]> {
    return metadataRepository.list(options);
  };
}
